import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FeatureCallesEsriModel } from '../models/feature-calles-esri.model';
import { ObjetoCallesEsriModel } from '../models/objeto-calles-esri.model';
import { ObjetoNumerosEsriModel } from '../models/objeto-numeros-esri.model';

@Injectable({
  providedIn: 'root'
})
export class RutasService {
  constructor(
    private httpClient: HttpClient
  ) { }
  baseSearchCalles = `${environment.base_url_esri_10_ava_calles}?where=OBJECTID%20%3E%200%20AND%20REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(LOWER(NOM_CALLE),%27á%27,%27a%27),%27é%27,%27e%27),%27í%27,%27i%27),%27ó%27,%27o%27),%27ú%27,%27u%27)%20LIKE%27%25`;
  middleSearchCalles = '%25%27%20OR%20LOWER(TIPO_VIA_T)%20LIKE%27%25';  
  finBaseSearchCalles = '%25%27&outFields=COD_AYTO%2CTIPO_VIA_T%2CNOM_CALLE&f=json&returnGeometry=true&orderByFields=NOM_CALLE&outSR=4326';

  baseSearchNumeros = `${environment.base_url_esri_10_ava_portales}?f=json&where=IDAYTO%20%3D%20`;
  finBaseSearchNumeros = '&returnGeometry=true&spatialRel=esriSpatialRelIntersects&outFields=IDAYTO%2CNPOL_%2CDUPLI_&orderByFields=NPOL_%2CDUPLI_&outSR=4326';

  private replaceAccents(word: string) {
    let r=word.toLowerCase();
    r = r.replace(new RegExp(/[àáâãäå]/g),'a'); // a
    r = r.replace(new RegExp(/[èéêë]/g),'e'); // e
    r = r.replace(new RegExp(/[ìíîï]/g),'i'); // i
    r = r.replace(new RegExp(/[òóôõö]/g),'o'); // o
    r = r.replace(new RegExp(/[ùúûü]/g),'u'); // u
    return r;
  }

  autoSearchCalles(nombreCalle: string): Observable<ObjetoCallesEsriModel> {
    const searchString = this.replaceAccents(nombreCalle);
    return this.httpClient.get<ObjetoCallesEsriModel>(`${this.baseSearchCalles}${searchString}${this.middleSearchCalles}${searchString}${this.finBaseSearchCalles}`);
  }

  autoSearchNumeros(codAyto: number): Observable<ObjetoNumerosEsriModel> {
    return this.httpClient.get<ObjetoNumerosEsriModel>(`${this.baseSearchNumeros}${codAyto}${this.finBaseSearchNumeros}`);
  }

}
